import React, { useState } from 'react';
import { Home, Bell, HelpCircle } from 'lucide-react';
import headerlogo from '../assets/headerLogo.svg';
import logoutIcon from '../assets/logoutIcon.png';
import HelpModal from './HelpModal';

const HeaderShell = ({
  showHomeButton,
  onHomeClick,
  showBellButton,
  unreadCount,
  onBellClick,
  showLogoutButton,
  onLogoutClick,
}) => {
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  return (
    <header
      className="fixed top-0 left-0 w-full bg-[#E2E1FD] z-50"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="w-full px-3 h-14 flex items-center justify-between">
        <div className="flex items-center flex-shrink-0 min-w-0">
          <img
            src={headerlogo}
            alt="factrika logo"
            className="object-contain h-8 w-auto max-w-[160px]"
          />
        </div>

        <div className="flex items-center gap-1 flex-shrink-0">
          {showHomeButton && (
            <button
              onClick={onHomeClick}
              className="flex items-center justify-center w-9 h-9 text-indigo-600 hover:text-indigo-700 hover:bg-indigo-100 rounded-full transition-colors duration-200"
              title="Go to Dashboard"
            >
              <Home className="w-5 h-5" />
            </button>
          )}

          {showBellButton && (
            <button
              onClick={onBellClick}
              className="relative flex items-center justify-center w-9 h-9 text-indigo-600 hover:text-indigo-700 hover:bg-indigo-100 rounded-full transition-colors duration-200"
              title="Notifications"
            >
              <Bell className="w-5 h-5" />
              {unreadCount > 0 && (
                <span className="absolute -top-0.5 -right-0.5 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 shadow-md">
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </button>
          )}

          <div className="relative">
            <button
              onClick={() => setIsHelpOpen((prev) => !prev)}
              className="flex items-center justify-center w-9 h-9 text-indigo-600 hover:text-indigo-700 hover:bg-indigo-100 rounded-full transition-colors duration-200"
              title="Help"
            >
              <HelpCircle className="w-5 h-5" />
            </button>
            <HelpModal isOpen={isHelpOpen} onClose={() => setIsHelpOpen(false)} />
          </div>

          {showLogoutButton && (
            <button
              onClick={onLogoutClick}
              className="flex items-center justify-center w-9 h-9 hover:bg-red-100 rounded-full transition-colors duration-200"
              title="Logout"
            >
              <img
                src={logoutIcon}
                alt="Logout"
                className="w-4 h-4"
                style={{ filter: 'brightness(0) saturate(100%)' }}
              />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default HeaderShell;